<template>
	<div>
		<el-dialog
			:title="titleDialog"
			:visible="showDialog"
			@close="close"
			@open="create"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			append-to-body
			width="45%"
		>
			<!-- <v-form v-model="valid">
                <v-row>
                    <v-col cols="12" md="12">
                        <v-text-field v-model="form.name" outlined dense label="Nombre" required></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-text-field v-model="form.title" outlined dense label="Descripción" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field
                            label="Outlined"
                            outlined
                        ></v-text-field>
                        </v-col>
                </v-row>
            </v-form> -->

			<form autocomplete="off" @submit.prevent="submit">
				<v-row>
					<v-col cols="12" xl="12" lg="12" md="12" sm="12">
						<div class="form-group" :class="{ 'error--text': errors.name }">
							<label>Nombre</label>
							<el-input
								v-model="form.name"
								:readonly="form.id ? true : false"
							></el-input>
							<small
								class="error--text"
								v-if="errors.name"
								v-text="errors.name[0]"
							></small>
						</div>
					</v-col>
					<v-col cols="12" xl="12" lg="12" md="12" sm="12">
						<div class="form-group" :class="{ 'error--text': errors.title }">
							<label>Descripción</label>
							<el-input v-model="form.title"></el-input>
							<small
								class="error--text"
								v-if="errors.title"
								v-text="errors.title[0]"
							></small>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" xl="12" lg="12" md="12" sm="12">
						<el-button type="danger" @click.prevent="close()">Cancelar</el-button>
						<el-button type="primary" native-type="submit" :loading="loading">
							<template v-if="loading">
								Guardando...
							</template>
							<template v-else>
								Guardar
							</template>
						</el-button>
					</v-col>
				</v-row>
			</form>
		</el-dialog>
	</div>
</template>

<script>
// import {EventBus} from '../../../helpers/bus'

export default {
	props: ['showDialog', 'recordId'],
	data() {
		return {
			loading: false,
			titleDialog: null,
			resource: 'permissions',
			valid: false,
			errors: {},
			form: {},
		};
	},
	created() {},
	methods: {
		initForm() {
			this.errors = {};
			this.form = {
				id: null,
				name: null,
				title: null,
				guard_name: 'web',
			};
		},
		create() {
			this.titleDialog = this.recordId ? 'Editar permiso' : 'Nuevo permiso';
			if (this.recordId) {
				this.$http.get(`/${this.resource}/record/${this.recordId}`).then((response) => {
					this.form = response.data.data;
				});
			}
		},
		submit() {
			this.loading = true;
			this.$http
				.post(`/${this.resource}`, this.form)
				.then((response) => {
					if (response.data.success) {
						this.$message.success(response.data.message);
						this.$eventHub.$emit('reloadData', this.resource);
						this.close();
					} else {
						this.$message.error(response.data.message);
					}
				})
				.catch((error) => {
					if (error.response.status === 422) {
						this.errors = error.response.data.errors;
					} else {
						this.$message.error(error.response.data.message);
					}
				})
				.then(() => {
					this.loading = false;
				});
		},
		close() {
			this.$emit('update:showDialog', false);
			this.initForm();
		},
	},
};
</script>
